import { createReducer } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { CommonState, AlertMessage, AlertType } from '../types/common.types';
import { showAlert, hideAlert, clearAlert } from '../actions/common.actions';

const COMMON_INITIAL_STATE: CommonState = {
    alert: {
        messages: []
    }
};

export const commonReducer = createReducer(COMMON_INITIAL_STATE, (builder) => {
    builder
        .addCase(showAlert, (state, action) => {
            const { message, type = AlertType.NEUTRAL, duration = 3000 } = action.payload;
            const newMessage: AlertMessage = {
                id: uuidv4(),
                message,
                type,
                duration
            };
            state.alert.messages.push(newMessage);
        })
        .addCase(hideAlert, (state, action) => {
            const messageId = action.payload;
            state.alert.messages = state.alert.messages.filter((msg) => msg.id !== messageId);
        })
        .addCase(clearAlert, (state) => {
            state.alert.messages = [];
        });
});
